import * as Yup from 'yup'

export const schema = (t: (key: string) => string) => ({
  transportCompanyUuid: Yup.string()
    .required(t('requiredMessage')),
  value: Yup.string()
    .required(t('requiredMessage')),
  type: Yup.string()
    .required(t('requiredMessage'))
})
